export default function BleConnectivityIcon(props: any) {
  return (
    <svg
      width="80"
      height="80"
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.2606 39.3327L38.2832 39.3101L38.2606 39.2892V39.3327Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.3048 3.47656L38.2822 3.49917L38.2613 3.52178V8.37569V36.7531L21.6439 20.1374L19.1743 22.6087L35.8352 39.2661L19.1309 55.9705L21.6074 58.447L38.2613 41.7931V60.8679V70.2366V75.1009L38.3048 75.1444L57.4787 55.9705L41.7396 40.2313L40.7761 39.2661L41.7396 38.3044L57.4369 22.6087L38.3048 3.47656ZM41.7396 11.854L52.4943 22.6087L41.7396 33.3618V11.854ZM41.7396 45.1827L52.5256 55.9705L41.7396 66.7566V45.1827Z"
        fill="#231F20"
      />
    </svg>
  );
}
